import { Toaster as HotToaster, toast } from 'react-hot-toast'
import { Icon } from '@/components/ui/icon'
import React from 'react'

const Toaster = () => {
  return (
    <HotToaster
      position="bottom-right"
      toastOptions={{
        className:
          'bg-popover border border-border p-4 text-sm text-popover-foreground rounded-lg shadow-lg',
        style: {
          padding: '0',
        },
        success: {
          icon: (
            <Icon name="check-circle" className="ml-2 h-3 w-3 text-green-500" />
          ),
        },
        error: {
          icon: <Icon name="x-circle" className="ml-2 h-3 w-3 text-red-500" />,
        },
        // You can add custom icons for other types as well
        // info: {
        //   icon: <Icon name="info" className="h-3 w-3 text-blue-500" />,
        // },
        // warning: {
        //   icon: <Icon name="alert-triangle" className="h-3 w-3 text-yellow-500" />,
        // },
      }}
    />
  )
}

export { Toaster, toast }
